


function Confirmation() {
    return (
   <div id="confirm">
   <h2>Congrats!</h2>
   <h3>Your seats are booked</h3>
   </div>
   

);
}

export default Confirmation;